import { useEffect } from "react";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { MainContent } from "./components/MainContent";
import { AppPageLayout } from "./components/AppPageLayout";
import { VersionManagement } from "./pages/VersionManagement";
import { UnitsTable } from "./pages/UnitsTable";
import { WeaponsTable } from "./pages/WeaponsTable";
import { UnitDetail } from "./pages/UnitDetail";
import { WeaponDetail } from "./pages/WeaponDetail";
import { DeckBuilder } from "./pages/DeckBuilder";
import { DeckImport } from "./pages/DeckImport";
import { UnitComparison } from "./pages/UnitComparison";
import { DamageCalculator } from "./pages/DamageCalculator";
import { DivisionAnalysisEditor } from "./pages/DivisionAnalysisEditor";
import { DivisionsPage } from "./pages/DivisionsPage";
import { PatchNotes } from "./pages/PatchNotes";
import { DeckLibrary } from "./pages/DeckLibrary";
import { DeckDetail } from "./pages/DeckDetail";
import { DeckDrafter } from "./pages/DeckDrafter";
import { DecksHub } from "./pages/DecksHub";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { AccountSettings } from "./pages/AccountSettings";
import {
  LegacyDivisionAnalysisRedirect,
  LegacyDivisionBriefingRedirect,
  LegacyDivisionEditorDescriptorRedirect,
  LegacyDivisionEditorIndexRedirect,
} from "./pages/legacy-division-redirects";
import { ComparisonModalProvider } from "./components/DeckBuilder/ComparisonModalManager";
import { ComparisonModalWrapper } from "./components/DeckBuilder/ComparisonModalWrapper";
import { Toaster } from "./components/ui/toaster";

export function App() {
  useEffect(() => {
    // Initialize theme on app load to prevent flash of wrong theme
    const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
    
    if (savedTheme) {
      if (savedTheme === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    } else {
      // Default to dark mode
      document.documentElement.classList.add("dark");
    }

  }, []);

  return (
    <ComparisonModalProvider>
      <BrowserRouter>
        <div className="flex h-screen min-h-0 w-full min-w-0 flex-col overflow-x-hidden bg-background">
          <Header />
          <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
            <Routes>
            <Route path="/" element={<div className="flex h-full min-h-0 flex-col overflow-y-auto bg-transparent"><MainContent /></div>} />
            <Route path="/versions" element={<AppPageLayout><VersionManagement /></AppPageLayout>} />
            <Route path="/units" element={<AppPageLayout><UnitsTable /></AppPageLayout>} />
            <Route path="/units/:descriptorName" element={<AppPageLayout><UnitDetail /></AppPageLayout>} />
            <Route path="/weapons" element={<AppPageLayout><WeaponsTable /></AppPageLayout>} />
            <Route path="/weapons/:descriptorName" element={<AppPageLayout><WeaponDetail /></AppPageLayout>} />
            <Route path="/unit-comparison" element={<AppPageLayout><UnitComparison /></AppPageLayout>} />
            <Route path="/damage-calculator" element={<AppPageLayout><DamageCalculator /></AppPageLayout>} />
            <Route path="/damage-calculator/:unitId" element={<AppPageLayout><DamageCalculator /></AppPageLayout>} />
            <Route path="/deck-builder" element={<AppPageLayout fillViewport><DeckBuilder /></AppPageLayout>} />
            <Route path="/deck-builder/:divisionId" element={<AppPageLayout fillViewport><DeckBuilder /></AppPageLayout>} />
            <Route path="/deck-import" element={<AppPageLayout><DeckImport /></AppPageLayout>} />
            <Route path="/divisions/editor/:descriptor" element={<AppPageLayout><DivisionAnalysisEditor /></AppPageLayout>} />
            <Route path="/divisions/editor" element={<AppPageLayout><DivisionAnalysisEditor /></AppPageLayout>} />
            <Route path="/divisions" element={<AppPageLayout><DivisionsPage /></AppPageLayout>} />
            <Route path="/division-analysis/editor/:descriptor" element={<LegacyDivisionEditorDescriptorRedirect />} />
            <Route path="/division-analysis/editor" element={<LegacyDivisionEditorIndexRedirect />} />
            <Route path="/division-briefing" element={<LegacyDivisionBriefingRedirect />} />
            <Route path="/division-analysis" element={<LegacyDivisionAnalysisRedirect />} />
            <Route path="/patch-notes" element={<AppPageLayout><PatchNotes /></AppPageLayout>} />
            <Route path="/deck-library" element={<AppPageLayout><DeckLibrary /></AppPageLayout>} />
            <Route path="/deck/:deckId" element={<AppPageLayout><DeckDetail /></AppPageLayout>} />
            <Route path="/deck-drafter" element={<AppPageLayout fillViewport><DeckDrafter /></AppPageLayout>} />
            <Route path="/decks" element={<AppPageLayout><DecksHub /></AppPageLayout>} />
            <Route path="/privacy-policy" element={<AppPageLayout><PrivacyPolicy /></AppPageLayout>} />
            <Route path="/account-settings" element={<AppPageLayout><AccountSettings /></AppPageLayout>} />
            </Routes>
          </div>
          <ComparisonModalWrapper />
          <Toaster />
        </div>
      </BrowserRouter>
    </ComparisonModalProvider>
  );
}

export default App;
